<app-header></app-header>
<div [class.features]="!isKaRegistration()">
    <div ngSkipHydration>
    @if (showSessionExpiredBanner()) {
    <div class="session-expired-banner">
        <img src="assets/images/banner-icon.svg" alt="Session expired" class="icon">
        <div class="banner-title">
            {{ 'sessionExpired' | translate }}
            <div class="banner-description">{{ 'sessionExpiredError' | translate }}</div>
        </div>
    </div>
    }
    </div>
    <router-outlet />
</div>
<app-footer></app-footer>